"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBlockHeaderRibbonFont = exports.withPaneTitleFont = exports.withPrimaryButtonFont = exports.withLightLabelFont = exports.withBlueLabelFont = exports.withSubtitleFont = exports.withEmphasisFont = exports.withBoldFont = exports.withDefaultButtonFont = exports.withDangerLinkButtonFont = exports.withDiscreetLinkButtonFont = exports.withLinkButtonFont = exports.withDividerFont = exports.withPlaceholderFont = exports.withWidgetSubtitleFont = exports.withBoldTitleFont = exports.withWidgetTitleFont = exports.withTopBarFont = exports.withFormLabelFont = exports.withDefaultFont = void 0;

require("../../fonts/open-sans/fonts.css");

var _Colors = require("./Colors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var withDefaultFont = function withDefaultFont(style) {
  return _objectSpread({
    fontFamily: "'Open Sans',Helvetica,Arial,sans-serif",
    fontWeight: 'normal',
    color: _Colors.blackTextColor,
    fontSize: '1rem',
    lineHeight: '1.4'
  }, style);
};

exports.withDefaultFont = withDefaultFont;

var withFormLabelFont = function withFormLabelFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: '300',
    color: _Colors.discreetTextColor
  }), style);
};

exports.withFormLabelFont = withFormLabelFont;

var withTopBarFont = function withTopBarFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: 'bold',
    fontSize: '1.2rem',
    lineHeight: '1.2'
  }), style);
};

exports.withTopBarFont = withTopBarFont;

var withWidgetTitleFont = function withWidgetTitleFont(style) {
  return Object.assign(withDefaultFont({
    fontSize: '1.1rem'
  }), style);
};

exports.withWidgetTitleFont = withWidgetTitleFont;

var withBoldTitleFont = function withBoldTitleFont(style) {
  return Object.assign(withDefaultFont({
    fontSize: '1.2rem',
    fontWeight: 'bold'
  }), style);
};

exports.withBoldTitleFont = withBoldTitleFont;

var withWidgetSubtitleFont = function withWidgetSubtitleFont(style) {
  return Object.assign(withDefaultFont({
    fontSize: '0.8rem',
    lineHeight: '1.4',
    color: _Colors.discreetTextColor,
    textTransform: 'none'
  }), style);
};

exports.withWidgetSubtitleFont = withWidgetSubtitleFont;

var withPlaceholderFont = function withPlaceholderFont(style) {
  return Object.assign(withDefaultFont({
    fontSize: '0.9rem',
    lineHeight: '1.4',
    color: _Colors.discreetTextColor,
    textTransform: 'none'
  }), style);
};

exports.withPlaceholderFont = withPlaceholderFont;

var withDividerFont = function withDividerFont(style) {
  return Object.assign(withDefaultFont({
    fontSize: '0.9rem',
    color: _Colors.discreetTextColor,
    textTransform: 'uppercase'
  }), style);
};

exports.withDividerFont = withDividerFont;

var withLinkButtonFont = function withLinkButtonFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.2',
    color: _Colors.primaryColor,
    textTransform: 'uppercase'
  }), style);
};

exports.withLinkButtonFont = withLinkButtonFont;

var withDiscreetLinkButtonFont = function withDiscreetLinkButtonFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1.2',
    color: _Colors.discreetTextColor,
    textTransform: 'uppercase'
  }), style);
};

exports.withDiscreetLinkButtonFont = withDiscreetLinkButtonFont;

var withDangerLinkButtonFont = function withDangerLinkButtonFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.2',
    color: _Colors.dangerColor,
    textTransform: 'uppercase'
  }), style);
};

exports.withDangerLinkButtonFont = withDangerLinkButtonFont;

var withDefaultButtonFont = function withDefaultButtonFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: 600,
    color: _Colors.blackTextColor,
    fontSize: '1.1rem'
  }), style);
};

exports.withDefaultButtonFont = withDefaultButtonFont;

var withBoldFont = function withBoldFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: 600,
    color: _Colors.blackTextColor
  }), style);
};

exports.withBoldFont = withBoldFont;

var withEmphasisFont = function withEmphasisFont(style) {
  return Object.assign(withBoldFont({
    fontWeight: 600,
    color: _Colors.primaryColor,
    fontSize: '1.15rem'
  }), style);
};

exports.withEmphasisFont = withEmphasisFont;

var withSubtitleFont = function withSubtitleFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: '600',
    color: _Colors.discreetTextColor,
    fontSize: '0.85rem'
  }), style);
};

exports.withSubtitleFont = withSubtitleFont;

var withBlueLabelFont = function withBlueLabelFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: '600',
    color: _Colors.blueLabelFontColor,
    fontSize: '0.85rem'
  }), style);
};

exports.withBlueLabelFont = withBlueLabelFont;

var withLightLabelFont = function withLightLabelFont(style) {
  return Object.assign(withDefaultFont({
    fontWeight: 'normal',
    color: _Colors.discreetTextColor,
    fontSize: '0.68rem',
    textTransform: 'uppercase'
  }), style);
};

exports.withLightLabelFont = withLightLabelFont;

var withPrimaryButtonFont = function withPrimaryButtonFont(style) {
  return Object.assign(withDefaultButtonFont({
    color: 'white'
  }), style);
};

exports.withPrimaryButtonFont = withPrimaryButtonFont;

var withPaneTitleFont = function withPaneTitleFont(style) {
  return Object.assign(withBoldTitleFont({
    fontSize: '1.4rem',
    fontWeight: '700',
    whiteSpace: 'nowrap'
  }), style);
};

exports.withPaneTitleFont = withPaneTitleFont;

var withBlockHeaderRibbonFont = function withBlockHeaderRibbonFont(style) {
  return Object.assign(withBoldTitleFont({
    fontSize: '1rem',
    fontWeight: '400',
    whiteSpace: 'nowrap',
    color: 'white'
  }), style);
};

exports.withBlockHeaderRibbonFont = withBlockHeaderRibbonFont;